import { render } from "./RegionSKO.vue?vue&type=template&id=38262c34&ts=true"
import script from "./RegionSKO.vue?vue&type=script&lang=ts"
export * from "./RegionSKO.vue?vue&type=script&lang=ts"

import "./RegionSKO.vue?vue&type=style&index=0&id=38262c34&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__